// Header.js

import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from './assets/ddc-demo.png';
import animatingflag from './assets/WavingFlag.gif';
import { useNavigate } from 'react-router-dom';

function Header({ onLanguageSwitch }) {
  const [isEnglish, setIsEnglish] = useState(false);
  const [displayText, setDisplayText] = useState('');
  const navigate = useNavigate();

  const languageSwitcher = () => {
    setIsEnglish(!isEnglish);
    if (onLanguageSwitch) {
      onLanguageSwitch(isEnglish);
    }
  };

  const homepageswitcher = ()=>{
    navigate('/');
  }
  useEffect(() => {
    // Function to animate text letter by letter
    const animateText = (text, speed) => {
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText(text.substring(0, index + 1));
        index++;

        if (index === text.length + 1) {
          clearInterval(intervalId);
        }
      }, speed);
    };

    // Get the text based on language and start the animation
    const textToDisplay = isEnglish
      ? 'Geographical Overview and Infographics of Educational Institutions'
      : 'शैक्षिक संस्थाहरूको भौगोलिक अवलोकन र इन्फोग्राफिक्स';

    animateText(textToDisplay, 20);
  }, [isEnglish]);

  return (
    <header>
      <div className="header-container">
        <div className="text-container">
          <img src={logo} onClick={homepageswitcher} alt="Logo" className="logo" />
          <div className='text'>
            <h1>{isEnglish ? 'Sudurpashchim Province' : 'सुदूरपश्चिम प्रदेश'}</h1>
            {/* Display the animated text */}
            <p>{displayText}</p>
          </div>
        </div>
        <div className='language_switcher'>
          <a href="#" onClick={languageSwitcher}>{isEnglish ? 'Nepali Language' : 'नेपाली भाषा'}</a>
          <label className="switch">
            <input type="checkbox" onChange={languageSwitcher} checked={!isEnglish} />
            <span className="slider round"></span>
          </label>
        </div>
        <img src={animatingflag} alt="Logo" className="animatingflag" />
      </div>
    </header>
  );
}

export default Header;
